import { ArrowConnector } from "./arrow";
/**
 * @see https://developers.arrow.com/api/index.php/site/page?view=v4isSearchToken
 */
export class VericalConnector extends ArrowConnector {
    websiteCode = "verical";
}
//# sourceMappingURL=verical.js.map